import { Layout } from 'components/layout';
import React, { useEffect, useState } from 'react';
import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '../carousel/carousel';

export const Infrastructure = () => {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }

    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);

    api.on('select', () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);

  const slidesList = [
    {
      number: '1',
      label: 'минуту пешком',
      description: 'ДО ПАРКА  ИМЕНИ Л.Н. ТОЛСТОГО',
      image: '/assets/images/png/slide-1.png',
    },
    {
      number: '9',
      label: 'минут на автобусе',
      description: 'ДО станциИ «Санино» (МЦД-4)',
      image: '/assets/images/png/slide-2.jpg',
    },
    {
      number: '250',
      label: 'метра',
      description: 'ДО ДЕТСКОГО САДА',
      image: '/assets/images/png/slide-3.png',
    },
    {
      number: '300',
      label: 'метров',
      description: 'ДО торгового центра',
      image: '/assets/images/png/celovek-delaet-pokupki-v-maske.jpg',
    },
    {
      number: '350',
      label: 'метров',
      description: 'ДО поликлиники',
      image: '/assets/images/png/slide-5.png',
    },
    {
      number: '500',
      label: 'метров',
      description: 'До школы',
      image: '/assets/images/png/slide-6.png',
    },
  ];

  return (
    <section className="font-open-sans">
      <Layout.Container>
        <div className="mt-[60px] px-[33px] mb-[50px] screen-900:mt-0">
          <h3 className="uppercase font-bold text-[32px] text-center screen-700:text-lg">
            Инфраструктура
          </h3>
          <Carousel setApi={setApi}>
            <div className="flex gap-12 mt-16 screen-900:grid screen-900:mt-6 screen-900:gap-6">
              <div className="max-w-[380px] w-full mt-[43px] flex flex-col justify-between shrink-0 screen-900:mx-auto">
                <div className="screen-900:mx-auto screen-900:w-fit">
                  <div className="flex items-end border-b border-[#757575B2]/70 screen-900:justify-center">
                    <h6 className="font-bold text-[92px] leading-[120%]">
                      {slidesList[current - 1]?.number}
                    </h6>
                    <p className="font-semibold text-xl mb-5">
                      {slidesList[current - 1]?.label}
                    </p>
                  </div>
                  <p className="uppercase text-xl font-semibold mt-5 screen-900:text-center screen-700:text-xs">
                    {slidesList[current - 1]?.description}
                  </p>
                </div>
                <div className="flex items-center justify-end gap-2 screen-900:hidden">
                  <div className="mr-4">
                    <span className="font-serif text-[30px] text-plt-black">
                      0{current}
                    </span>
                    <span className="text-[17px] text-[#9F9F9F]">
                      /0{count}
                    </span>
                  </div>
                  <CarouselPrevious className="relative left-auto right-auto bottom-auto size-[56px] border-2 border-plt-secondary " />
                  <CarouselNext className="relative right-auto bottom-auto size-[56px] border-2 border-plt-secondary" />
                </div>
              </div>
              <CarouselContent>
                {slidesList.map((slide) => (
                  <CarouselItem
                    key={slide.number}
                    className="w-full screen-900:w-full max-h-[408px]"
                  >
                    <div className="w-full max-h-[408px] rounded-[40px] rounded-se-none overflow-hidden screen-900:w-full">
                      <img
                        src={slide.image}
                        alt={slide.description}
                        className="w-full max-h-[408px] object-cover object-center"
                      />
                    </div>
                  </CarouselItem>
                ))}
              </CarouselContent>
              <div className="hidden screen-900:flex justify-center gap-2 mt-6">
                <CarouselPrevious className="static size-[56px] border-plt-secondary border-2" />
                <CarouselNext className="static size-[56px] border-plt-secondary border-2" />
              </div>
            </div>
          </Carousel>
        </div>
      </Layout.Container>
    </section>
  );
};
